module.exports = __webpack_public_path__ + "img/s6Icon4.90ca4f2a.png";